module.exports = __webpack_public_path__ + "static/media/meihaper.5de6423d.png";